import { useState } from "react";
import { ArrayFieldTemplateProps } from "@rjsf/utils";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import TitleFieldTemplate from "../TitleFieldTemplate";
import { Row, Col } from "antd";
import { TrashIcon, PlusIcon } from "@heroicons/react/24/outline";
import styles from "./CollapsibleArrayFieldTemplate.module.css";

/**
 * A custom array field template that adds collapsible functionality
 * for first level array fields so they are consistent with other first level objects.
 */
const CollapsibleArrayFieldTemplate = ({
  idSchema,
  title,
  items,
  onAddClick,
  canAdd,
  //formData,
  //formContext,
  //disabled,
  //readonly,
  required,
}: ArrayFieldTemplateProps) => {
  // Extract id from idSchema
  const id = idSchema.$id || "";
  
  // The description might be in the schema
  const description = "";
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className={`w-full bg-white rounded-xl shadow-md pb-2 ${styles.container}`} id={id}>
      <div className="form-group mb-3">
        <div
          className="flex justify-between items-center p-6 rounded cursor-pointer pb-4"
          onClick={toggleCollapse}
        >
          <TitleFieldTemplate
            id={id}
            title={title || ""}
            required={required}
            schema={{}}
            depth={0}
          />

          <button type="button" className="text-blue-500">
            {collapsed ? (
              <ChevronDownIcon className="w-6 h-6 text-primary_800" />
            ) : (
              <ChevronUpIcon className="w-6 h-6 text-primary_800" />
            )}
          </button>
        </div>
        {!collapsed && (
          <div className="pl-6 pr-16">
            {description && (
              <div
                className="mb-4"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            <div className="custom-object-field-template ">
      
      <Row gutter={6}>
        <Col span={24}>
          {items &&
            items.map((element, index) => {
              return (
                <div
                  key={index}
                  className="custom-array-item flex gap-2 flex-row items-center justify-start"
                >
                  <div className="w-full"> {element.children}</div>
                 
                  <button
                    onClick={element.onDropIndexClick(index)}
                    className={`button-delete-collapsible-array button-ghost hover:text-secondary_600 ${index === 0 ? "mt-4" : "mb-4"}`}
                  >
                    <TrashIcon className="h-4 w-4 " />
                  </button>
                </div>
              );
            })}
        </Col>
        {canAdd && (
          <Row className="flex flex-row items-start justify-start w-full ">
            <button
              onClick={onAddClick}
              className="button-primary button-add-collapsible-array border-2 py-1 px-2 text-white rounded-xl border-primary_800  hover:bg-white hover:text-primary_900 hover:border-primary_900 active:text-primary_900"
            >
              <PlusIcon className="h-4 w-4 " />
            </button>
          </Row>
        )}
      </Row>
    </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CollapsibleArrayFieldTemplate;
